import UserImagePlaceholder from 'common/components/Displays/UserImagePlaceholder'
import { pagesPaths } from 'common/router/routes.utils'
import Image from 'next/image'
import Link from 'next/link'
import styled from 'styled-components'
import { IJob } from '../jobs.types'
import { getSalaryIconCurrency } from '../jobs.utils'

interface IProps {
  job: IJob
}
export const JobCard = ({ job }: IProps) => {
  const getMonthlySalaryLabel = (job: IJob): string | false => {
    if (job.salaryFrom && job.salaryTo) {
      return `${job.salaryFrom} - ${job.salaryTo}`
    }
    if (job.salaryFrom) {
      return `Starting from ${job.salaryFrom}`
    }
    if (job.salaryTo) {
      return `Up to ${job.salaryTo}`
    }
    return false
  }
  const monthlySalaryLabel = getMonthlySalaryLabel(job)
  const details = [
    { label: 'Position', value: job.position.name || 'Not mentioned' },
    { label: 'Category', value: job.jobCategory.name || 'Not mentioned' },
  ]

  if (job.totalExperience?.value) {
    details.push({ label: 'Min Experience', value: `${job.totalExperience.value} years` })
  }

  if (job.signOnDate) {
    details.push({ label: 'Sign on', value: job.signOnDate })
  }

  if (job.vessel) {
    details.push({ label: 'Vessel', value: job.vessel.name })
  }

  if (job.hiringMultipleCount) {
    details.push({ label: 'Vacancies', value: job.hiringMultipleCount.toString() })
  }

  return (
    <Link href={`${pagesPaths.jobs}/${job.slug ? job.slug?.[job.slug?.length - 1] : job.id}/view`}>
      <Div className="p-4 flex flex-column gap-5 border-round-xl shadow-2 hover:shadow-1 cursor-pointer bg-secondary_10">
        <div className="card-header">
          <div className="card-image border-circle flex align-items-center justify-content-center overflow-hidden bg-white">
            {job.company?.logo_file_path ? (
              <Image
                src={job.company?.logo_file_path}
                alt={job.company.name}
                width={110}
                height={110}
                priority={false}
                style={{ objectFit: 'contain' }}
              />
            ) : (
              <UserImagePlaceholder className="border-circle" size="large" />
            )}
          </div>

          <div className="flex align-items-center h-full gap-4 flex-grow-1">
            <div>
              <div className="flex justify-content-between font-bold text-base break-word">{job.title}</div>
              <div className="flex gap-1">
                {'Salary: '}
                {monthlySalaryLabel ? (
                  <div className="flex gap-1 align-center">
                    {getMonthlySalaryLabel(job)} <i className={getSalaryIconCurrency(job.salaryCurrency)} />
                  </div>
                ) : (
                  'To be discussed'
                )}
              </div>

              <div>{job.company.name}</div>
            </div>
          </div>
        </div>

        <ul className="details">
          {details.map((detail) => (
            <li key={detail.label}>
              <div className="gray-70">{detail.label}</div>
              <div className="font-semibold">
                {detail.value.length > 15 ? (
                  <span title={detail.value}>{`${detail.value.slice(0, 15)}...`}</span>
                ) : (
                  detail.value
                )}
              </div>
            </li>
          ))}
        </ul>
      </Div>
    </Link>
  )
}

const Div = styled.div`
  width: 100%;
  font-size: 13px;
  height: 100%;

  > .card-header {
    display: grid;
    grid-template-columns: 120px 1fr;
    gap: 1rem;

    > .card-image {
      height: 110px;
      width: 110px;
    }
  }

  > .details {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 0.75rem;
  }
  ul {
    list-style: none;
  }
`
